export default "__VITE_ASSET__Dcbf1qJM__"